import React from "react";
import styles from "./Loading.module.css";
import logo from "../../assets/logo.png";

const Loading = () => {
  return (
    <div className={styles.loader}>
      <div className={styles.loaderContainer}>
        <div className={styles.bankName}>
          <h2>KHATTRI BANK </h2>
        </div>
        <div className={styles.logoAnimation}>
          {/* Replace with your bank logo */}
          <img src={logo} alt="Bank Logo" />
        </div>
      </div>
    </div>
  );
};

export default Loading;
